import React from "react";
import { Card, CardContent, CardActions, CardHeader, Typography, Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import Button from './Button';
import { Refresh } from '@mui/icons-material';

export default function SubsciptionCard({ data, handleClickDelete, handleClickRefresh, handleClickNotifyEmail, handleClickNotifyPhone, userInfo, disabled }) {

  const rightAlignStyle = {
    marginLeft: "auto",
    paddingRight: 1
  }

  const formatExpiration = (expiration) => {
    return "Expires " + (new Date(expiration * 1000)).toDateString();
  }

  const Subheader = ({ expiration, id }) => (
    <div>
      <p style={{ float: "left", margin: 0 }}>
        {formatExpiration(expiration)}
      </p>
      <p style={{ float: "right", margin: 0 }}>
        <Button 
          disabled={disabled}
          sx={{ p: 0, pl: 3, pr: 3 }} 
          startIcon={<Refresh />} 
          onClick={() => !disabled && handleClickRefresh(id)} 
        >
          Renew
        </Button>
      </p>
    </div>
  );

  const capitalizeFirst = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };
  
  return (
    <Card 
      variant='outlined' 
      sx={{ m: 3, boxShadow: "none", borderRadius: 0, borderColor: "black" }}
    >
      <React.Fragment>
        <CardHeader 
          title={capitalizeFirst(data.brand)}
          subheader={userInfo?.collector ? null : <Subheader expiration={data.ttl} id={data.id} />}
        />
        <CardContent>
          <Typography variant="body2" color="text.secondary">
            {capitalizeFirst(data.description)}
          </Typography>
        </CardContent>
        <CardActions disableSpacing>
          <FormGroup>
            {/* <Button size="small" >History</Button> */}
            <Button 
              size="small" 
              onClick={() => handleClickDelete(data.id)}
            >
              Delete
            </Button>
          </FormGroup>
          <FormGroup sx={rightAlignStyle}>
            <FormControlLabel 
            control={
              <Checkbox 
                disabled={disabled}
                checked={data.notifyEmail} 
                onClick={() => !disabled && handleClickNotifyEmail(data.id, data.notifyEmail)} 
              />
            } 
            label="Email" 
            />
            <FormControlLabel 
              control={
                <Checkbox 
                  disabled={disabled}
                  checked={data.notifyPhone} 
                  onClick={() => !disabled && handleClickNotifyPhone(data.id, data.notifyPhone)} 
                />
              } 
              label="Phone" 
            />
          </FormGroup>
        </CardActions>
      </React.Fragment>
    </Card>
  );
}